import { useEffect, useState } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import Image from 'next/image';

import appQr from '../../../../../public/images/pdp/opendoor-app-qr.svg';

import styles from './AppDownloadQrCard.module.css';

export const AppDownloadQrCard = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setIsVisible(window.scrollY >= 200);

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  return (
    <Col
      as="aside"
      aria-label="Get the Opendoor app"
      aria-hidden={!isVisible}
      className={styles.card}
      data-visible={isVisible}
    >
      <Text as="span" className={styles.label}>
        Scan to get the app
      </Text>
      <Image
        src={appQr}
        alt="Scan to get the Opendoor app at opendoor.app.link/website"
        width={106}
        height={106}
        className={styles.qr}
        unoptimized
      />
    </Col>
  );
};
